import has from './internal/has'
import curry from './curry'

/* Creates a new object with the own properties of the two provided objects.
 * if a key exists in both objects, the provided function is applied to the key
 * and the values associated with the key in each object, with the result
 * being used as the value associated with the key in the returned object
 *
 * const concatValues = (key, obj1, obj2) => key === 'values' ? concatObject(obj1, obj2) : obj2
 * const merged = mergeWithKey(concatValues, 
 *     { a: true, thing: 'foo', values: [10, 20] },
 *     { b: true, thing: 'bar', values: [15, 35] }
 * )
 * merged -> { a: true, b: true, thing: 'bar', values: [10, 20, 15, 35] }
*/

const mergeWithKey = curry((fn, obj1, obj2) => {
	const result = {}
	let key

	for (key of Object.keys(obj1)) {
		if (has(key, obj1)) {
			result[key] = has(key, obj2)
				? fn(key, obj1[key], obj2[key])
				: obj1[key]
		}
	}
	for (key of Object.keys(obj2)) {
		if (has(key, obj2) && !(has(key, result))) {
			result[key] = obj2[key]
		} 
	}

	return result
})

export default mergeWithKey
